import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(private auth:AuthService,public router:Router) { }
  canActivate():boolean{
    if(this.auth.isAuthenticated()){
      return true
    }
    else{
      this.router.navigateByUrl("/signin")
      return false
    }
  }
}